<template>
    <div>
        <!-- UneCont -->
        <div class="modal fade" id="uneContModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">UneCont</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    :edicao="!$store.state.user.id_unidade_operacao"
                                    icon="far fa-building fa-fw"
                                    type="select"
                                    placeholder="Todas as Unidades..."
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    v-model="filtro.id_unidade_operacao" />
                            </div>
                            <div class="col col-12 col-md-6" v-if="filtro.id_unidade_operacao">
                                <az-input 
                                    type="number"
                                    placeholder="Evento..."
                                    v-model="filtro.num_evento">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <az-submit color="outline-primary" @click="load()" :hide_content_while_loading="true">
                                                <i class="fa-solid fa-rotate"></i>
                                            </az-submit>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="alert alert-info mt-3" v-if="dados">
                            <div>
                                Último Listado: <strong>{{ dados.UltimoEventoId }}</strong>
                            </div>
                            <div>
                                Total de Registros: <strong>{{ dados.MaximoEventoId }}</strong>
                            </div>
                        </div>
                        
                        <table class="table table-hover table-sm mt-3 small" v-if="dados && dados.lista && dados.lista.length > 0">
                            <thead>
                                <tr>
                                    <th>Num</th>
                                    <th>NF</th>
                                    <th>Emissão</th>
                                    <th>CPF/CNPJ</th>
                                    <th>Nome Fantasia</th>
                                    <th>Descrição</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in dados.lista" :key="idx">
                                    <td>{{ item.EventoId }}</td>
                                    <td>{{ item.campos.numero }}</td>
                                    <td>{{ $util.getFormatDate(item.campos.emissao) }}</td>
                                    <td>{{ item.campos.prestador ? item.campos.prestador.cnpj : '' }}</td>
                                    <td>{{ item.campos.prestador ? item.campos.prestador.nome : '' }}</td>
                                    <td class="small">{{ item.campos.descricao }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(item.campos.valor) }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <pre class="alert alert-info" v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            dados: null, 
            filtro: { 
                id_unidade_operacao: this.$store.state.user.id_unidade_operacao || "", 
                num_evento: "",
            },
        }
    },

    components: { 
        AzInput, 
        AzSubmit, 
    },

    methods: { 
        abrir() { 
            this.dados = null; 
            this.num_evento = ""; 

            $('#uneContModal').modal('show');
        },

        load() { 
            this.$util.load(this, { 
                service: 'financeiro',
                func: 'lista_une_cont', 
                parms: { 
                    ...this.filtro,
                },
                loadTo: res => { 
                    this.dados = res;
                }
            })
        },
    }
}
</script>
